/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestCndnGetApplicationGet } from '../fn/cndn-request/api-request-cndn-get-application-get';
import { ApiRequestCndnGetApplicationGet$Params } from '../fn/cndn-request/api-request-cndn-get-application-get';
import { apiRequestCndnGetReceiptForCnDnGet } from '../fn/cndn-request/api-request-cndn-get-receipt-for-cn-dn-get';
import { ApiRequestCndnGetReceiptForCnDnGet$Params } from '../fn/cndn-request/api-request-cndn-get-receipt-for-cn-dn-get';
import { apiRequestCndnGetRequestByIdGet } from '../fn/cndn-request/api-request-cndn-get-request-by-id-get';
import { ApiRequestCndnGetRequestByIdGet$Params } from '../fn/cndn-request/api-request-cndn-get-request-by-id-get';
import { apiRequestCndnInitialApplicationGet } from '../fn/cndn-request/api-request-cndn-initial-application-get';
import { ApiRequestCndnInitialApplicationGet$Params } from '../fn/cndn-request/api-request-cndn-initial-application-get';
import { apiRequestCndnInitialGet } from '../fn/cndn-request/api-request-cndn-initial-get';
import { ApiRequestCndnInitialGet$Params } from '../fn/cndn-request/api-request-cndn-initial-get';
import { apiRequestCndnSaveSubmitPost } from '../fn/cndn-request/api-request-cndn-save-submit-post';
import { ApiRequestCndnSaveSubmitPost$Params } from '../fn/cndn-request/api-request-cndn-save-submit-post';
import { CndnRequest } from '../models/cndn-request';
import { CndnRequestApiRespModel } from '../models/cndn-request-api-resp-model';
import { CourseBillingRequest } from '../models/course-billing-request';
import { ReceiptRequest } from '../models/receipt-request';
import { RequestCourse } from '../models/request-course';

@Injectable({ providedIn: 'root' })
export class CndnRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestCndnInitialGet()` */
  static readonly ApiRequestCndnInitialGetPath = '/api/Request/Cndn/Initial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnInitialGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnInitialGet$Response(params?: ApiRequestCndnInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequest>> {
    return apiRequestCndnInitialGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnInitialGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnInitialGet(params?: ApiRequestCndnInitialGet$Params, context?: HttpContext): Observable<CndnRequest> {
    return this.apiRequestCndnInitialGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CndnRequest>): CndnRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestCndnInitialApplicationGet()` */
  static readonly ApiRequestCndnInitialApplicationGetPath = '/api/Request/Cndn/InitialApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnInitialApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnInitialApplicationGet$Response(params?: ApiRequestCndnInitialApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseBillingRequest>> {
    return apiRequestCndnInitialApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnInitialApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnInitialApplicationGet(params?: ApiRequestCndnInitialApplicationGet$Params, context?: HttpContext): Observable<CourseBillingRequest> {
    return this.apiRequestCndnInitialApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseBillingRequest>): CourseBillingRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestCndnGetApplicationGet()` */
  static readonly ApiRequestCndnGetApplicationGetPath = '/api/Request/Cndn/GetApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnGetApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetApplicationGet$Response(params?: ApiRequestCndnGetApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RequestCourse>>> {
    return apiRequestCndnGetApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnGetApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetApplicationGet(params?: ApiRequestCndnGetApplicationGet$Params, context?: HttpContext): Observable<Array<RequestCourse>> {
    return this.apiRequestCndnGetApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RequestCourse>>): Array<RequestCourse> => r.body)
    );
  }

  /** Path part for operation `apiRequestCndnGetRequestByIdGet()` */
  static readonly ApiRequestCndnGetRequestByIdGetPath = '/api/Request/Cndn/GetRequestById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnGetRequestByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetRequestByIdGet$Response(params?: ApiRequestCndnGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequest>> {
    return apiRequestCndnGetRequestByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnGetRequestByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetRequestByIdGet(params?: ApiRequestCndnGetRequestByIdGet$Params, context?: HttpContext): Observable<CndnRequest> {
    return this.apiRequestCndnGetRequestByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CndnRequest>): CndnRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestCndnGetReceiptForCnDnGet()` */
  static readonly ApiRequestCndnGetReceiptForCnDnGetPath = '/api/Request/Cndn/GetReceiptForCnDn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnGetReceiptForCnDnGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetReceiptForCnDnGet$Response(params?: ApiRequestCndnGetReceiptForCnDnGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReceiptRequest>>> {
    return apiRequestCndnGetReceiptForCnDnGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnGetReceiptForCnDnGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCndnGetReceiptForCnDnGet(params?: ApiRequestCndnGetReceiptForCnDnGet$Params, context?: HttpContext): Observable<Array<ReceiptRequest>> {
    return this.apiRequestCndnGetReceiptForCnDnGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReceiptRequest>>): Array<ReceiptRequest> => r.body)
    );
  }

  /** Path part for operation `apiRequestCndnSaveSubmitPost()` */
  static readonly ApiRequestCndnSaveSubmitPostPath = '/api/Request/Cndn/SaveSubmit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCndnSaveSubmitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCndnSaveSubmitPost$Response(params?: ApiRequestCndnSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequestApiRespModel>> {
    return apiRequestCndnSaveSubmitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCndnSaveSubmitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCndnSaveSubmitPost(params?: ApiRequestCndnSaveSubmitPost$Params, context?: HttpContext): Observable<CndnRequestApiRespModel> {
    return this.apiRequestCndnSaveSubmitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CndnRequestApiRespModel>): CndnRequestApiRespModel => r.body)
    );
  }

}
